{
  "ReportingLevel": "CX Analytics:",
  "DefaultReports": "Default Reports:",
  "ReportingApi": "Reporting API:",
  "ReportingApiHint": "Allows the supervisor to download report data through the API",
  "EnhancedFeatures": "Enhanced Mobile App Features:",
  "EnhancedFeaturesHint": "Allows the supervisor to view additional reports on the mobile app (Agent List, Extension List, Group List, Unreturned Lost Calls, Calls By 1/2 Hour & Day)",
  "CallRecording": "Call Recording Integration:",
  "ReadOnly": "Read Only Report Access:",
  "ReadOnlyHint": "The supervisor can only access reports on a view only basis. Note: This setting will be disabled if the user is a report template user.",
  "ReportTemplateUser": "Report Template User:",
  "ReportTemplateUserHint": "The user can only create report templates and access them through the API, they cannot view reports. Note: This setting will be disabled if the user is a read only report user.",
  "RecordingNone": "[None Selected]",
  "ReportingLevelTypesNone": "No Reporting",
  "ReportingLevelTypesPersonal": "Personal Reporting",
  "ReportingLevelTypesEnterprise": "Enterprise Reporting",
  "ReportingLevelTypesCallCentreSupervisor": "Call Centre Supervisor Reporting",
  "ReportingLevelTypesSupervisor": "Supervisor Reporting",
  "NoReports": "No Reports",
  "AccessLevelNone": "None",
  "AccessLevelPresence": "Presence User",
  "AccessLevelOne": "ONE User",
  "AccessLevelLite": "Lite Supervisor",
  "AccessLevelEnterprise": "Enterprise User",
  "AccessLevelEnterprise_MST": "CXA Advanced (Historic) User",
  "AccessLevelCallCentreSupervisor": "Call Centre Supervisor",
  "AccessLevelCallCentreSupervisor_MST": "CXA Advanced User",
  "AccessLevelCallCentreSupervisor_WxC": "WxC Supervisor",
  "AccessLevelEssentials": "Essentials User",
  "AccessLevelEssentials_MST": "CXA Standard User",
  "AccessLevelEssentials_WxC": "WxC User",
  "AccessLevelProfessional": "Professional User",
  "AccessLevelProfessional_MST": "CXA Premium User",
  "AccessLevelCallCentreAgent": "Call Centre Agent",
  "AccessLevelCallCentreAgent_MST": "CXA Premium User",
  "AccessLevelCallCentreAgent_WxC": "WxC Agent",
  "AccessLevelHistoricUser": "Historic User",
  "AccessLevelRealTimeUser": "Real-Time User",
  "AccessLevelAgent": "Agent",
  "AccessLevelManager": "Manager",
  "AccessLevel1000": "1000 Supervisor",
  "AccessLevel2000": "2000 Supervisor",
  "ReportingTour_Step1": "Displays a list of all current active reports",
  "ReportingTour_Step2": "Click to again expand side navigation",
  "ReportingTour_Step2_New": "Click to expand reporting menu",
  "ReportingTour_Step3": "Click here to start creating a new report",
  "ReportingTour_Step4": "Select the desired report style from the dropdown list",
  "ReportingTour_Step5": "Specify a custom name for your report",
  "ReportingTour_Step6": "Simplify your report library by creating or assigning a folder for your new report",
  "ReportingTour_Step7": "Set the date and time range required for the report",
  "ReportingTour_Step8": "Click here to advance to the reports filtering options",
  "ReportingTour_Step9": "Set your report to return metrics in relation to calls made by or received at specific telephone numbers, devices or agents",
  "ReportingTour_Step10": "Through the miscellaneous filtering settings, you can further restrict the results of your report based on settings such as whether the call was answered or not, the inbound DDI dialled or calls where specific account codes were entered",
  "ReportingTour_Step11": "Click here to advance to the reports field settings",
  "ReportingTour_Step12": "This box displays the full list of fields currently contained within the report, as well as providing options to move fields up and down this list. You may also add and remove new fields, reset all fields to the default settings, and remove all fields from the report",
  "ReportingTour_Step13": "Click here to add a new field",
  "ReportingTour_Step14": "Select the type of statistic you are looking to add to the report",
  "ReportingTour_Step15": "Select the channel type for the statistic, be this voice, chat or email",
  "ReportingTour_Step16": "Specify the field you are looking to add from within the presented list",
  "ReportingTour_Step17": "Review the available fields for any further statistics you may wish to return, or untick any that you may wish to remove",
  "ReportingTour_Step18": "Once satisfied, review the list to ensure any additions are now present",
  "ReportingTour_Step19": "Click here to advance to the reports scheduling settings",
  "ReportingTour_Step20": "Expand the dropdown box to specify the frequency you wish the report schedule to run on",
  "ReportingTour_Step21": "Click on the desired schedule frequency to set it",
  "ReportingTour_Step22": "Specify the day of the week and approximate time you wish for the report to run on",
  "ReportingTour_Step23": "Set the desired report format (pdf, csv or rtf) as well as the language, and paper size for the report",
  "ReportingTour_Step24": "Once satisfied, click on OK to save your changes and load the new report",
  "ReportingTour_Step25": "Click here to collapse the side navigation menu",
  "NAME": "ReportingLanguage"
}
